import getWrappedUseMutation from "api/helpers/getWrappedUseMutation";
import apiClient from "api-client";

export const useCreateTeamMemberMutation = getWrappedUseMutation(apiClient.ForumTeamMember.post);

export const useUpdateTeamMemberMutation = getWrappedUseMutation(apiClient.ForumTeamMember.put);

export const useDeleteTeamMemberMutation = getWrappedUseMutation(apiClient.ForumTeamMember.delete);
